import { createReducer, on } from '@ngrx/store';
import { User } from '../../models/user.model';
import * as fromUserActions from '../actions/users.action';

export interface UserState {
    data: User;
    loaded: boolean;
    loading: boolean;
    error: string;
}

export const initialState: UserState = {
    data: undefined as any,
    loaded: false,
    loading: false,
    error: ''
};

export const userReducer = createReducer(
    initialState,
    on(fromUserActions.AddUserAction, (state) => ({ ...state, loading: true })),
    on(fromUserActions.AddUserSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromUserActions.AddUserFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromUserActions.DeleteUserAction, (state) => ({ ...state, loading: true })),
    on(fromUserActions.DeleteUserSuccessAction, (state) => ({ ...state, data: undefined as any, loaded: true, loading: false })),
    on(fromUserActions.DeleteUserFailAction, (state, { error }) => ({ ...state, error: error.message })),
    on(fromUserActions.UpdateUserAction, (state) => ({ ...state, loading: true })),
    on(fromUserActions.UpdateUserSuccessAction, (state, { data }) => ({ ...state, data: data, loaded: true, loading: false })),
    on(fromUserActions.UpdateUserFailAction, (state, { error }) => ({ ...state, error: error.message })),
);
